import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Process_master = () => {
  const location = useLocation();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 마스터 과정`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/process_basic">베이직 과정</a>
              </li>
              <li>
                <a href="/process_grow">그로우 과정</a>
              </li>
              <li>
                <a href="/process_master" className="sel">
                  마스터 과정
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="process_master process">
          <div className="sect process01 master01">
            <div className="wrap">
              <div className="tit-wrap">
                <div className="tit init">
                  초등 교육과정 학습 <br />
                  바탕 다지기 단계{" "}
                </div>
                <div className="txt init">
                  체계적인 문해력 학습 과정에 맞추어 <br />
                  사고력과 창의력을 키울 수 있는 단계로
                  <br /> 초등 교육과정 학습을 준비하는 과정입니다.
                </div>
              </div>
              <div className="img">
                <img
                  src="../custom-resources/img/img_process01_master01_img_ver2024.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect process02 master02">
            <div className="wrap">
              <div className="sub init">
                <img src="../custom-resources/img/img_process_title3.png" alt="" />
                <p>마스터 과정</p>
              </div>
              <div className="tit init">누가 배우면 좋을까요?</div>
              <div className="txt init">
                <p>
                  <strong>마스터 과정</strong>은 학습의 기본 개념을 탄탄하게{" "}
                  <br className="mo-view" />
                  다진 아이들을 대상으로 구성되었습니다.
                  <br />
                  <span className="neon init">
                    스스로 생각하고 표현할 수 있도록 구성
                  </span>
                  된 마스터 교재로 <br />
                  아이들의 풍부한 사고력과 창의력을 더욱 키워 줍니다.
                </p>
              </div>
            </div>
          </div>
          <div className="sect process03 master03">
            <div className="wrap">
              <div className="tit init">국어와 수학의 융합형 교재입니다.</div>
              <div className="txt init">
                심화 한글 학습으로 사고력과 표현력을 키워 주고 통합적 사고력과
                응용력 및 작문 능력까지 키웁니다.
                <br />
                수학 전 영역의 심화 학습을 통해 응용력, 통합적 사고력, 창의력을
                향상시킵니다.
              </div>
            </div>
          </div>
          <div className="sect process04-intro master04-intro">
            <div className="wrap">
              <div className="tit init">마스터 교재를 소개합니다!</div>
              <div className="img init pc-view">
                <img
                  src="../custom-resources/img/img_process_master04_img00.png"
                  alt=""
                />
              </div>
              <div className="img init mo-view">
                <img
                  src="../custom-resources/img/img_process_master04_img00_m.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect process04 master04">
            <div className="wrap">
              <div className="prs">
                <ul>
                  <li className="init">
                    <div className="name">국어군</div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_master04_img01_2024.png"
                        alt=""
                      />
                    </div>
                    <div className="con">
                      <dl>
                        <dt>교재 이름</dt>
                        <dd>기초 문해력</dd>
                      </dl>
                      <dl>
                        <dt>교재 구성</dt>
                        <dd>1호 ~ 5호 (5권)</dd>
                      </dl>
                      <dl>
                        <dt>교재 특징</dt>
                        <dd>
                          문장 구조의 기초적인 구성을 익혀 생각을 문장으로 쓰는
                          방법을 <br className="pc-view" /> 학습하는 논술의
                          기초를 학습하는 문해력 교재입니다.
                        </dd>
                      </dl>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_master04_img02_2024.png"
                        alt=""
                      />
                    </div>
                    <div className="con">
                      <dl>
                        <dt>교재 이름</dt>
                        <dd>기본 문해력</dd>
                      </dl>
                      <dl>
                        <dt>교재 구성</dt>
                        <dd>1호 ~ 10호 (10권)</dd>
                      </dl>
                      <dl>
                        <dt>교재 특징</dt>
                        <dd>
                          디지털 NIE, 일기 쓰기, 문장 코딩, 매체 SQ3R 활동을
                          통해 <br className="pc-view" />
                          생각을 글로 표현하는 다양한 방법을 익히는 유아 문해력
                          완성
                          <br className="pc-view" /> 교재입니다.
                        </dd>
                      </dl>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_master04_img03_2024.png"
                        alt=""
                      />
                    </div>
                    <div className="con">
                      <dl>
                        <dt>교재 이름</dt>
                        <dd>창의 논술</dd>
                      </dl>
                      <dl>
                        <dt>교재 구성</dt>
                        <dd>1호 ~ 4호 (4권)</dd>
                      </dl>
                      <dl>
                        <dt>교재 특징</dt>
                        <dd>
                          주제에 관련된 다양한 글을 통해 배경지식을 확장하고
                          NIE,
                          <br className="pc-view" /> 일기, 독서논술, 통합논술을
                          통해 자기 생각을 글로 스스럼없이
                          <br className="pc-view" /> 쓰게 하는 창의력 증진 논술
                          프로그램입니다.
                        </dd>
                      </dl>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_master04_img04_2024.png"
                        alt=""
                      />
                    </div>
                    <div className="con">
                      <dl>
                        <dt>교재 이름</dt>
                        <dd>한자</dd>
                      </dl>
                      <dl>
                        <dt>교재 구성</dt>
                        <dd>1-상호 ~ 37호 (44권)</dd>
                      </dl>
                      <dl>
                        <dt>교재 특징</dt>
                        <dd>
                          생활 속에서 접할 수 있는 기초 한자를 이미지와 함께
                          친근하게 <br className="pc-view" />
                          접근하여 학습하는 교재로 한글의 이해력과 독해력을 높여
                          주는
                          <br className="pc-view" /> 한자 학습 교재입니다.
                        </dd>
                      </dl>
                    </div>
                  </li>
                  <li className="init">
                    <div className="name">수학군</div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_master04_img05_2024.png"
                        alt=""
                      />
                    </div>
                    <div className="con">
                      <dl>
                        <dt>교재 이름</dt>
                        <dd>사고력 수학</dd>
                      </dl>
                      <dl>
                        <dt>교재 구성</dt>
                        <dd>1호 ~ 10호 (10권)</dd>
                      </dl>
                      <dl>
                        <dt>교재 특징</dt>
                        <dd>
                          교과서에서 학습하는 4개 영역(수와 연산, 변화와 관계,
                          도형과
                          <br /> 측정 자료와 가능성)을 규칙, 측정, 공간, 수,
                          기하로 세분화하여
                          <br /> 수학적 개념을 익히는 사고력 프로그램입니다.
                        </dd>
                      </dl>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_master04_img06_2024.png"
                        alt=""
                      />
                    </div>
                    <div className="con">
                      <dl>
                        <dt>교재 이름</dt>
                        <dd>창의 수학</dd>
                      </dl>
                      <dl>
                        <dt>교재 구성</dt>
                        <dd>1호 ~ 4호 (4권)</dd>
                      </dl>
                      <dl>
                        <dt>교재 특징</dt>
                        <dd>
                          프로젝트 주제에 대해 수학의 기본적인 개념을 창의적이고
                          다각적으로 경험하며 창의융합적 사고력과 문제 해결력을
                          키우는 프로젝트 형식의 프로그램입니다.
                        </dd>
                      </dl>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_master04_img07_2024.png"
                        alt=""
                      />
                    </div>
                    <div className="con">
                      <dl>
                        <dt>교재 이름</dt>
                        <dd>칠교</dd>
                      </dl>
                      <dl>
                        <dt>교재 구성</dt>
                        <dd>1호 ~ 24호 (24권)</dd>
                      </dl>
                      <dl>
                        <dt>교재 특징</dt>
                        <dd>
                          일곱 개의 칠교 조각으로 다양하게 만들고, 창의적으로{" "}
                          <br className="pc-view" />
                          사고하도록 발문하며 수학적 개념과 융합하여 창의적
                          사고력을 <br className="pc-view" />
                          키우는 프로젝트화된 입체적 사고력 창의 학습
                          프로그램입니다.
                        </dd>
                      </dl>
                    </div>
                  </li>
                  <li className="plus init">
                    <div className="name name2">특별 프로그램 - 두뇌 톡톡</div>
                    <div className="act">
                      <a href="/program_learning">자세히 알아보기 ▶</a>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_grow04_img06_2024.png"
                        alt=""
                      />
                    </div>
                    <div className="con">
                      <dl>
                        <dt>교재 이름</dt>
                        <dd>두뇌 톡톡 프로그램</dd>
                      </dl>
                      <dl>
                        <dt>교재 구성</dt>
                        <dd>1-1호 ~ 12-3호 (36권)</dd>
                      </dl>
                      <dl>
                        <dt>교재 특징</dt>
                        <dd>
                          발달 수준에 맞는 학습 능력을 높여주는 프로그램입니다.
                        </dd>
                      </dl>
                    </div>
                  </li>
                  <li className="init">
                    <div className="name name2">특별 프로그램 - 언어 톡톡</div>
                    <div className="act">
                      <a href="/program_language">자세히 알아보기 ▶</a>
                    </div>
                    <div className="img">
                      <img
                        src="../custom-resources/img/img_process_grow04_img07_2024.png"
                        alt=""
                      />
                    </div>
                    <div className="con">
                      <dl>
                        <dt>교재 이름</dt>
                        <dd>언어 톡톡 프로그램</dd>
                      </dl>
                      <dl>
                        <dt>교재 구성</dt>
                        <dd>1호 ~ 8호 (8권)</dd>
                      </dl>
                      <dl>
                        <dt>교재 특징</dt>
                        <dd>
                          술술 읽고 쏙쏙 이해하는 언어 감수성의 힘을 키워주는
                          프로그램입니다.
                        </dd>
                      </dl>
                    </div>
                  </li>
                  <li className="plus init">
                    <div className="name">창의교구 & 수학교구 & 칠교</div>
                    <div className="img nobd">
                      <img
                        src="../custom-resources/img/img_process_master04_img09.png"
                        alt=""
                      />
                    </div>
                    <div className="img nobd">
                      <img
                        src="../custom-resources/img/img_process_elementary04_img08_2024.png"
                        alt=""
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="sect process05 master05">
            <div className="wrap">
              <div className="tit init">
                하루 <span>1</span>시간, 건강한 학습 습관!
              </div>
              <div className="txt init">
                규칙적으로 하루 1시간, 과목별 고른 배분으로{" "}
                <br className="mo-view" />
                <span>학습생명력</span>을 키워줍니다.
              </div>
              <div className="img init">
                <img
                  src="../custom-resources/img/img_process_master05_img01_2024.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect process06 master06">
            <div className="wrap init">
              <div className="tit">아소비 교습비</div>
              <div className="txt">
                <p>교습비 : 187,000원 ~</p>
                <span>
                  ※ 학원형의 경우, 주 5일 수업 또는 차량 운행 여부에 따라 변동
                  <br className="mo-view" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Process_master;
